import { UrlHelper } from '../utils/UrlHelper';

export class ReferenceLink {
  constructor(private readonly text: string, private readonly url: string | null) {}

  getText() {
    return this.text;
  }

  getHref() {
    if (this.url) {
      return UrlHelper.wrapKnowledgeBaseUrl(this.url);
    }
    return null;
  }
}
